// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"OwnModal_modal_wrapper__D2Imf","close_icon":"OwnModal_close_icon__mix4I","own_modal":"OwnModal_own_modal__Xf1IW"};